<template>
  <v-dialog v-model="dialogModel" max-width="700px" persistent scrollable role="dialog" aria-labelledby="formTitle">
    <v-card class="group-form-card">
      <v-card-text class="pt-4">
        <div v-if="hasChildren">
          <p>
            {{ $i18n.t("This group has children. Are you sure you want to delete the group and all its children?") }}
          </p>
          <ul>
            <li v-for="child in children" :key="child._id">
              {{ child.fullName || child.shortName }}
            </li>
          </ul>
        </div>
        <div v-else>
          {{ $i18n.t("Are you sure you want to delete the group") }} {{ group.fullName || group.shortName }}?
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-3 grey lighten-4">
        <v-spacer></v-spacer>
        <v-btn flat @click="closeDialog" :aria-label="$i18n.t('Cancel')">
          {{ $i18n.t("Cancel") }}
        </v-btn>
        <v-btn color="red darken-1" @click="deleteGroup" :aria-label="$i18n.t('Delete group')">
          <v-icon left small>delete</v-icon>
          {{ $i18n.t("Delete") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmDialog",
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    children: {
      type: Array,
      default: () => []
    },
    group: {
      type: Object,
      default: () => ({
        shortName: "",
        fullName: "",
        type: "",
        address: "",
        description: "",
        parent: null,
        manager: null,
        client: null,
        contract: null,
        users: []
      })
    }
  },
  computed: {
    dialogModel: {
      get() {
        return this.dialog;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      }
    },
    hasChildren() {
      return this.children && this.children.length > 0;
    }
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    async deleteGroup() {
      try {
        if (this.hasChildren) {
          this.children.forEach(child => this.$store.dispatch("group/deleteGroup", child._id));
        }
        await this.$store.dispatch("group/deleteGroup", this.group._id);
      } catch (error) {
        throw error;
      }
      this.$emit("group-delete");
    }
  }
};
</script>
